// extracted by mini-css-extract-plugin
module.exports = {"root":"OrganizationItem_root__34Cre","inputCustom":"OrganizationItem_inputCustom__1B1io","item":"OrganizationItem_item__21ZY4"};